import { NoteTextarea } from '@/shared/ui/common/note-textarea';
import { FieldSection } from '@/shared/ui/forms/field-section';

type Props = {
    value: string;
    onChange: (value: string) => void;
};

export function NessoAdditionalNotes({ value, onChange }: Props) {
    return (
        <FieldSection title="Additional Notes" className="gap-9">
            <FieldSection label="Additional notes">
                <NoteTextarea value={value} onChange={onChange} placeholder="" rows={3} />
                <p className="text-xs text-muted-foreground">
                    Insights, session takeaways, referrals, etc.
                </p>
            </FieldSection>
        </FieldSection>
    );
}
